import tail from 'tail.select/js/tail.select-full.min';

export default class CustomSelect {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.select-tail:not(.page-select)'), el => {
			new CustomSelect(el);
		});
	}

	constructor(el) {
		const selectOptions = {
			search: false,
			descriptions: false,
			count: false,
			hideSelected: false,
			multiple: false,
			stayOpen: false,
			deselect: false,
			placeholder: el.getAttribute('title') || ''
		}
		return tail(el, selectOptions);
	}
}
